import {React} from 'external/react'
import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  useMediaQuery,
  useTheme
}
from 'external/material'

import {pickAttributes} from 'helpers/utils'

export default function ResponsiveDialog(props) {
  const {open, close, confirm, cancel, TitleComponent} = props
  const theme = useTheme()
  const fullScreen = useMediaQuery(theme.breakpoints.down('md'))
  const dialogProps = pickAttributes(props, 'dialog')
  const titleProps = pickAttributes(props, 'head')
  const contentProps = pickAttributes(props, 'content')
  const actionsProps = pickAttributes(props, 'actions')

  return (
    <Dialog
      fullScreen={fullScreen}
      open={open}
      onClose={e => close(e)}
      aria-labelledby="responsive-dialog-title"
      {...dialogProps}
    >
      {props.title && (<DialogTitle id="responsive-dialog-title" {...titleProps}>{props.title}</DialogTitle>)}
      {TitleComponent && (<DialogTitle id="responsive-dialog-title" {...titleProps}><TitleComponent /></DialogTitle>)}
      <DialogContent {...contentProps}>
        {props.children}
      </DialogContent>
      <DialogActions {...actionsProps}>
        {cancel && cancel}
        {confirm && confirm}
      </DialogActions>
    </Dialog>
  )
}
